import { LoadableLazy } from '@confluence/loadable';

export const LazyGetMobileAppDialog = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-GetMobileAppDialog" */ './GetMobileAppDialog'))
			.GetMobileAppDialog,
});
